module.exports = __webpack_public_path__ + "static/FS-Barrier-1-3-1e2a797a738e883eef4de702deb8a712.png";